var _excluded = ["children", "className", "icon", "inverse", "sentiment", "size", "weight"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { BulletPoint } from "../Icon";
import { useInverse } from "../BackgroundProvider";
import Text from "../Text";
import StyledListItem, { StyledListItemBulletContainer, StyledListItemIconContainer } from "./styled";
import { useTheme } from 'styled-components';

/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/list)
 **/
var ListItem = function ListItem(_ref) {
  var children = _ref.children,
    customClassName = _ref.className,
    _ref$icon = _ref.icon,
    iconProp = _ref$icon === void 0 ? 'bullet-point' : _ref$icon,
    inverseProp = _ref.inverse,
    _ref$sentiment = _ref.sentiment,
    sentiment = _ref$sentiment === void 0 ? 'inherit' : _ref$sentiment,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's2' : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'normal' : _ref$weight,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme() || {};
  var inverse = inverseProp !== undefined ? inverseProp : useInverse(theme);
  var className = classnames('csl-list-item', {
    'csl-list-item--icon': Boolean(iconProp),
    'csl-list-item--inverse': Boolean(inverse),
    customClassName: customClassName
  });
  var icon = useMemo(function () {
    if (typeof iconProp === 'string') {
      if (iconProp !== 'bullet-point') {
        console.warn('ListItem component no longer accepts strings in the `icon` prop. Please pass in an Icon component as JSX instead.');
      }
      return /*#__PURE__*/React.createElement(StyledListItemBulletContainer, {
        className: "csl-list-item__icon-bullet-container"
      }, /*#__PURE__*/React.createElement(BulletPoint, {
        color: sentiment,
        iconSize: "default",
        inverse: inverse,
        size: size,
        trim: true
      }));
    }
    return /*#__PURE__*/React.createElement(StyledListItemIconContainer, {
      className: "csl-list-item__icon-container"
    }, iconProp);
  }, [iconProp, inverse]);
  return /*#__PURE__*/React.createElement(StyledListItem, _extends({
    $marginBottom: "04"
  }, rest, {
    className: className
  }), /*#__PURE__*/React.createElement(Text, {
    inverse: inverse,
    size: size,
    weight: weight
  }, children), icon);
};
ListItem.displayName = 'ListItem';
export default ListItem;